import { useTranslator } from '@bluebeam/react-i18n';
import Immutable, { List } from 'immutable';
import React from 'react';
import { ProjectGroup } from 'records/ProjectGroup';
import AssigneeItem from './AssigneeItem';

interface Props {
  searchGroups: List<ProjectGroup>;
  selectedGroups: Immutable.OrderedSet<string>;
  handleAddSelectedGroup: (option: string) => void;

  searchIndividuals: Immutable.OrderedSet<string>;
  selectedAssignees: Immutable.OrderedSet<string>;
  handleAddSelectedAssignee: (option: string) => void;
}

const AssigneesSearchResults: React.FC<Props> = (props: Props) => {
  const {
    searchGroups,
    selectedGroups,
    handleAddSelectedGroup,
    searchIndividuals,
    selectedAssignees,
    handleAddSelectedAssignee,
  } = props;

  const { translate } = useTranslator(['assigneesSearchResults']);

  const groupSearchResultAdapt = (group: ProjectGroup) => {
    return searchResultAdapt(
      group.name,
      group.groupid,
      handleAddSelectedGroup,
      group.groupid
    );
  };

  const individualSearchResultAdapt = (individual: string) => {
    return searchResultAdapt(
      individual,
      individual,
      handleAddSelectedAssignee,
      individual
    );
  };

  const searchResultAdapt = (
    displayName: string,
    key: string,
    clickCallback: (option: string) => void,
    clickCallbackParam: string
  ) => {
    return { displayName, key, clickCallback, clickCallbackParam };
  };

  const filteredGroups = searchGroups
    .filter((group) => !selectedGroups.includes(group.groupid))
    .map((group) => groupSearchResultAdapt(group));

  const filteredIndividuals = searchIndividuals
    .filter((individual) => !selectedAssignees.includes(individual))
    .map((individual) => individualSearchResultAdapt(individual))
    .toList();

  const searchResult = filteredGroups
    .concat(filteredIndividuals)
    .sort((a, b) => a.displayName.localeCompare(b.displayName));

  return (
    <>
      <div className="oa" style={{ height: '176px' }}>
        {searchResult.size > 0 ? (
          <div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: 500,
                padding: '0px 0px 10px 26px',
                borderBottom: 'solid 1px #e2e1e1',
                lineHeight: '20px',
              }}
            >
              {translate('assigneesSearchResults:results')}
            </div>
            {searchResult.map((result) => (
              <AssigneeItem
                handleAddSelected={result.clickCallback}
                option={result.clickCallbackParam}
                key={result.key}
                displayName={result.displayName}
              />
            ))}
          </div>
        ) : (
          <div>
            <div
              className="row px4"
              style={{
                fontSize: '16px',
                fontWeight: 500,
                lineHeight: '20px',
                padding: '8px 0px 10px 26px',
              }}
            >
              {translate('assigneesSearchResults:noResults')}
            </div>
            <div
              className="row px4"
              style={{
                fontSize: '14px',
                lineHeight: '21px',
                color: '#4b585d',
                padding: '0px 60px 0px 28px',
              }}
            >
              {translate('assigneesSearchResults:noMatch')}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default AssigneesSearchResults;
